import { useEffect, useState } from "react";

// Единая точка определения мобильной ширины (≤768px) для блока тарифов.
// Используется и в Tarifs.jsx (скрытие пустых табов), и в TarifsCards.jsx
// (выбор мобильного рендера). CRA — window есть всегда, SSR-guard не нужен.
const QUERY = "(max-width: 768px)";

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(QUERY).matches);

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    setIsMobile(mql.matches); // на случай смены между initial state и effect
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
};

export default useIsMobile;
